
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-text-dark text-white overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Logo y Descripción */}
          <div>
            <div className="flex items-center mb-3 sm:mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/3f5d024e-3e6d-4d97-ae36-0220e5cf8b45.png" 
                alt="PLADUREX Logo" 
                className="h-10 sm:h-12 w-auto brightness-0 invert flex-shrink-0"
              />
              <span className="ml-2 sm:ml-3 text-xl sm:text-2xl font-bold text-white">PLADUREX</span>
            </div>
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4 break-words">
              Instalación profesional de pladur en L'Hospitalet de Llobregat y Barcelona. Acabados perfectos, obra limpia y rápida.
            </p>
          </div>

          {/* Enlaces */}
          <div>
            <h2 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Servicios</h2>
            <ul className="space-y-1.5 sm:space-y-2">
              <li>
                <Link to="/servicios#tabiques" className="text-gray-400 hover:text-primary-light transition-colors cursor-pointer text-xs sm:text-sm break-words">
                  Tabiques de Pladur
                </Link>
              </li>
              <li>
                <Link to="/servicios#techos" className="text-gray-400 hover:text-primary-light transition-colors cursor-pointer text-xs sm:text-sm break-words">
                  Falsos Techos
                </Link>
              </li>
              <li>
                <Link to="/servicios#trasdosados" className="text-gray-400 hover:text-primary-light transition-colors cursor-pointer text-xs sm:text-sm break-words">
                  Trasdosados y Aislamiento
                </Link>
              </li>
              <li>
                <Link to="/servicios#reformas" className="text-gray-400 hover:text-primary-light transition-colors cursor-pointer text-xs sm:text-sm break-words">
                  Reformas Integrales
                </Link>
              </li>
            </ul>
            <h2 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 mt-6">Empresa</h2>
            <ul className="space-y-1.5 sm:space-y-2">
              <li>
                <Link to="/empresa" className="text-gray-400 hover:text-primary-light transition-colors cursor-pointer text-xs sm:text-sm break-words">
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-primary-light transition-colors cursor-pointer text-xs sm:text-sm break-words">
                  Preguntas Frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-400 hover:text-primary-light transition-colors cursor-pointer text-xs sm:text-sm break-words">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h2 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Contacto</h2>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-line text-primary-light mr-2 sm:mr-3 mt-0.5 sm:mt-1 flex-shrink-0"></i>
                <div>
                  <a href="tel:+34629501941" className="text-gray-400 hover:text-primary-light transition-colors cursor-pointer text-xs sm:text-sm break-all">
                    +34 629 501 941
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-whatsapp-line text-primary-light mr-2 sm:mr-3 mt-0.5 sm:mt-1 flex-shrink-0"></i>
                <div>
                  <a 
                    href="https://wa.me/34629501941" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-primary-light transition-colors cursor-pointer text-xs sm:text-sm break-words"
                  >
                    WhatsApp
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-primary-light mr-2 sm:mr-3 mt-0.5 sm:mt-1 flex-shrink-0"></i>
                <div className="text-gray-400 text-xs sm:text-sm break-words">
                  Área de servicio: L'Hospitalet de Llobregat + Barcelona
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-gray-400 text-xs sm:text-sm mb-3 md:mb-0 text-center md:text-left">
              © {currentYear} PLADUREX. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 md:gap-6">
              <Link 
                to="/politica-cookies"
                className="text-gray-400 hover:text-primary-light transition-colors text-xs sm:text-sm cursor-pointer whitespace-nowrap"
              >
                Política de Cookies
              </Link>
              <Link 
                to="/aviso-legal"
                className="text-gray-400 hover:text-primary-light transition-colors text-xs sm:text-sm cursor-pointer whitespace-nowrap"
              >
                Aviso Legal
              </Link>
              <Link 
                to="/politica-privacidad"
                className="text-gray-400 hover:text-primary-light transition-colors text-xs sm:text-sm cursor-pointer whitespace-nowrap"
              >
                Política de Privacidad
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
